import { put, takeEvery } from 'redux-saga/effects';
import { call, select } from 'typed-redux-saga';
import { authActionCreators } from '..';
import { IState } from '../..';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { getUser } from '../../users';
import * as api from '../authApi';
import { setAuthLocalStorageValue } from '../authLocalStorageService';

function* fetchItImpersonatePermissions(action: ReturnType<typeof authActionCreators.fetchItImpersonatePermissions>) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response = yield* call(api.FetchPermissions, action.payload.sid);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    let userMin: { name: string; sid: string } | undefined;
    const user = yield* select((state: IState) => getUser(state, action.payload.sid));

    if (user) {
      userMin = { name: user.name, sid: user.sid };
      setAuthLocalStorageValue('auth/itOverrideUser', userMin);
    }

    setAuthLocalStorageValue('auth/itOverridePermissions', response.value);
    yield put(authActionCreators.setItOverrides(response.value, userMin));
  }
  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchFetchItImpersonatePermissions() {
  yield takeEvery(authActionCreators.fetchItImpersonatePermissions.match, fetchItImpersonatePermissions);
}
